import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { resolveMockResponse } from './kcc20-mock-data';

/**
 * Serves in-repo fixtures for kcc20 API routes when `environment.useMockData`
 * is on (the `mock` build config). Any route without a fixture is passed
 * through to the real backend, so endpoints can be migrated to the real API
 * one at a time by deleting their fixture. A no-op in every other config.
 */
export const kcc20MockInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.useMockData) {
    return next(req);
  }
  const base = environment.apiBaseUrl.replace(/\/$/, '');
  if (!req.url.startsWith(base)) {
    return next(req);
  }
  const relativeUrl = req.url.slice(base.length);
  const [path, query = ''] = relativeUrl.split('?');
  const body = resolveMockResponse(
    req.method,
    path,
    new URLSearchParams(query),
  );
  if (body === undefined) {
    return next(req);
  }
  return of(new HttpResponse({ status: 200, body, url: req.url })).pipe(
    delay(150),
  );
};
